export var USER_ROLE_PREMIUM = process.env.REACT_APP_USER_ROLE_PREMIUM || 'ROLE_REALM_PREMIUM';
//# sourceMappingURL=config.js.map